import type { PropsWithChildren, RefObject } from 'react'
import React, { useRef } from 'react'

import { useAppContext } from 'aem-libs-react-ts/src/hooks/useAppContext'
import { useElementViewEffect } from 'aem-libs-react-ts/src/hooks/useElementViewEffect'
import { useMount } from 'aem-libs-react-ts/src/hooks/useMount'
import type { RenderOptions } from 'aem-libs-react-ts/src/inlet/renderApp'
import type { StaticParamsBase } from 'aem-libs-react-ts/src/types/common'
import { gaTracker } from 'aem-libs-react-ts/src/utils/gaTracker'

export type InletWrapperProps = Pick<RenderOptions<unknown>, 'viewTracking' | 'rootId'>

export const InletWrapper = ({
  children,
  viewTracking,
  rootId = 'web-inlet'
}: PropsWithChildren<InletWrapperProps>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { appName, paramsStatic, loggingOptions } = useAppContext<StaticParamsBase>()

  useMount(() => {
    if (loggingOptions?.client && loggingOptions?.enabledMountLogging) {
      loggingOptions?.client.log({
        type: 'INIT'
      })
    }
  })

  useElementViewEffect(containerRef as unknown as RefObject<HTMLDivElement>, () => {
    if (viewTracking) {
      gaTracker.withVariant(paramsStatic.variant).onView(appName)
    }
  })

  return (
    <div id={rootId} ref={containerRef}>
      <div id={'web-inlet-content'}>{children}</div>
    </div>
  )
}
